// =============================================================================
// components/KpiRules/KpiRuleList.jsx
//
// MUDANCAS fix2:
//   - Severidade vem dos lookups (BD) via useLookups(). Sem hardcoded.
//   - Removida linha do modo/criticalLimit (campos que ja nao existem em v8).
// =============================================================================
import {
	Box, Typography, Paper, Chip, IconButton, Tooltip, Divider,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { TECH_COLOR } from '../../constants/kpiConstants';
import { useLookups } from '../../hooks/useKpi';

function RuleCard({ rule, isSelected, onSelect, severityMap }) {
	const sev = severityMap[rule.severity];

	return (
		<Paper
			variant="outlined"
			sx={{
				p: 1.5,
				mb: 1,
				cursor: 'pointer',
				borderLeft: 4,
				borderLeftColor: (sev && sev.colorHex) || 'grey.400',
				backgroundColor: isSelected ? 'action.selected' : 'background.paper',
				'&:hover': { backgroundColor: 'action.hover' },
				transition: 'background-color 0.15s',
			}}
			onClick={function () { onSelect(rule); }}
		>
			<Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
				<Box sx={{ flex: 1, minWidth: 0 }}>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5 }}>
						<Typography variant="body2" fontWeight={600} noWrap sx={{ flex: 1 }}>
							{rule.kpiName}
						</Typography>
						{!rule.active && (
							<Chip label="Inativa" size="small" variant="outlined"
								sx={{ height: 18, fontSize: '0.65rem' }} />
						)}
					</Box>

					<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
						{sev && (
							<Chip
								label={sev.label}
								size="small"
								sx={{
									height: 18, fontSize: '0.65rem', fontWeight: 600,
									backgroundColor: sev.colorHex + '22', color: sev.colorHex,
								}}
							/>
						)}
						<Typography variant="caption" color="text.secondary">
							{rule.detectionMethod || 'PERCENTILE'} · SLA {rule.slaThreshold}
						</Typography>
					</Box>
				</Box>

				<Tooltip title="Editar">
					<IconButton size="small" onClick={function (e) { e.stopPropagation(); onSelect(rule); }}>
						<EditIcon fontSize="inherit" />
					</IconButton>
				</Tooltip>
			</Box>
		</Paper>
	);
}

export default function KpiRuleList({ rulesByTech, selectedId, onSelect }) {
	const { severityMap, loaded, load } = useLookups();
	const techs = Object.keys(rulesByTech).sort();

	// Garantia: se lookups ainda nao carregaram, dispara.
	if (!loaded) {
		// dispara mas nao bloqueia a renderizacao (severityMap sera {} ate carregar)
		setTimeout(function () { if (!loaded) load(); }, 0);
	}

	if (!techs.length) {
		return (
			<Box sx={{ p: 3, textAlign: 'center' }}>
				<Typography variant="body2" color="text.secondary">
					Nenhuma regra configurada. Clica em "Nova Regra" para começar.
				</Typography>
			</Box>
		);
	}

	return (
		<Box>
			{techs.map(function (tech) {
				return (
					<Box key={tech} sx={{ mb: 2 }}>
						<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
							<Box sx={{ width: 4, height: 18, bgcolor: TECH_COLOR[tech] || 'grey.500', borderRadius: 1 }} />
							<Typography variant="overline" fontWeight={700}>
								{tech}
							</Typography>
							<Typography variant="caption" color="text.secondary">
								({rulesByTech[tech].length})
							</Typography>
						</Box>
						<Divider sx={{ mb: 1 }} />
						{rulesByTech[tech].map(function (rule) {
							return (
								<RuleCard
									key={rule.kpiId}
									rule={rule}
									isSelected={selectedId === rule.kpiId}
									onSelect={onSelect}
									severityMap={severityMap}
								/>
							);
						})}
					</Box>
				);
			})}
		</Box>
	);
}